import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from './propertyQueryKeys'
import { getPropertyWindowExtension } from './propertyEndpoints'
import { parseWindowExtensionProposal } from './propertyParser'

// The funding window extension waiting on the owners, or null. Read only while
// the property is live — an extension is only ever proposed against a running
// window.
export function usePropertyWindowExtensionQuery(
  id: MaybeRefOrGetter<string>,
  isEnabled: MaybeRefOrGetter<boolean>,
) {
  return useQuery({
    queryKey: computed(() => propertyKeys.extension(toValue(id))),
    queryFn: () => getPropertyWindowExtension(toValue(id)).then(parseWindowExtensionProposal),
    enabled: computed(() => Boolean(toValue(id)) && toValue(isEnabled)),
  })
}
